import { scrollTo } from 'ui-utils';
import { setInnerHTML } from 'utils';

document.addEventListener('submitted', e => {
    const form = e.target.closest('.form-widget');

    if (!form)
        return;

    if (typeof e.detail.data === 'string') {
        setInnerHTML(form, e.detail.data);
        scrollTo(form);
    } else
        window.location.href = e.detail.data.successUrl;
}, true);